export namespace Favorito {
    export class Add {
        static readonly type = '[Favorito] Add';
        constructor(public payload: any) {}
    }

    export class Edit {
        static readonly type = '[Favorito] Edit';
        constructor(public payload: any) {}
    }

    export class FetchAll {
        static readonly type = '[Favorito] Fetch All';
    }

    export class Delete {
        static readonly type = '[Favorito] Delete';
        constructor(public id: number) {}
    }
}
